import { EnumFiscalResidence } from '@blank/api'
import { CountryConfig, EnumHomeCountryCode } from '../../types'

export const BLANK_IT_COUNTRY_CONFIG: CountryConfig = {
  canAddCompanyDataManually: true,
  companyIdentificationNumberLength: 11,
  shouldChooseDomiciliationOnSignup: true,
  isBeta: true,
  canAddEnterpriseMandate: true,
  shouldDisplayUserFeedbackButton: true,
  isSponsorshipEnabled: false,
  increaseTransferLimitTypeformId: 'v3ZysnUs',
  feedbackTypeformId: 'W7LXQDri',
  accountClosingTypeformId: 'R87qoBsW',
  shouldDisplayAdditionalTouOnSelectOffer: true,
  fiscalResidenceOptions: [EnumFiscalResidence.ITA, EnumFiscalResidence.USA],
  homeCountryCode: EnumHomeCountryCode.ITA,
  invoicing: {
    canCreateEstimateDocument: false,
    canAddFiscalTaxesToDocument: true,
    canAddFiscalStampToDocument: true,
    shouldSelectVATExonerationCode: true,
  },
  shouldDisplayAverageBalanceDocuments: true,
  shouldBuildMicroEnterpriseCreationURLWithParams: true,
  whatsAppSupportNumber: '+393513054772',
  shouldCustomizeCardFraudInsuranceRedirectionUrl: false,
  fileComplaintTypeformId: 'KoYlR5wq',
  shouldDisplayZendeskMessagingWidget: false,
  zendeskScriptKey: '',
  hasOptionalConsents: true,
}
